import store from '@/store';

import {
  SET_SERVICE_STATUS,
} from '@/lib/constants/mutations';

import { SERVICE_STATUS } from '@/forms/constants/services';

export default (serviceName) => {
  store.commit(SET_SERVICE_STATUS, {
    service: serviceName,
    status: SERVICE_STATUS.unvalidated,
  });
};
